import styled from 'styled-components';

interface MediaGalleryStProps {
  fullscreen: boolean;
  withBackground?: boolean;
}

export const MediaGallerySt = styled.div<MediaGalleryStProps>`
  position: relative;
  overflow: hidden;
  height: 100%;
  display: ${({ withBackground }) => withBackground && 'flex'};
  justify-content: ${({ withBackground }) => withBackground && 'center'};
  align-items: ${({ withBackground }) => withBackground && 'center'};

  @media (hover: hover) and (pointer: fine) {
    :hover {
      & > :nth-child(1) {
        display: ${({ withBackground }) => withBackground && 'flex'};
      }
      & > :nth-child(2) {
        display: ${({ withBackground }) => withBackground && 'flex'};
      }
    }
  }
`;

interface IMediaGalleryWrapperSt {
  withBackground?: boolean;
}

export const MediaGalleryWrapperSt = styled.div<IMediaGalleryWrapperSt>`
  position: ${({ withBackground }) => withBackground && 'relative'};
  height: ${({ withBackground }) => withBackground && '15rem'};
`;
